<template>
  <div data-guide-id="notice-subscribe-list">
    <remote-table
      ref="remoteTableRef"
      :columns="state.columns"
      :interfaceURL="state.dataUrl"
      :showSelection="false"
      :hasRefresh="false"
      :hasAction="false"
      :hasReset="false"
      :pageSize="20"
      :y="state.scrollY"
      :sy="state.scrollY"
      :apiParams="{}"
      @update:value="onTableDataLoaded"
    >
      <template #channelTypes="{ record }">
        <a-tag
          v-for="channel in getChannelLabels(record.channelTypes)"
          :key="channel.value"
          color="processing"
        >
          {{ channel.label }}
        </a-tag>
      </template>

      <template #action="{ record }">
        <a-button type="link" @click="onEdit(record)">订阅</a-button>
      </template>
    </remote-table>
  </div>

  <!-- 弹窗修改 --->
  <template>
    <a-modal
      v-model:visible="state.editEnable"
      title="通知订阅"
      centered
      width="50%"
      ok-text="确认"
      cancel-text="取消"
      @ok="saveOrUpdate"
    >
      <a-space direction="vertical" style="width: 100%">
        <!--站内信渠道-->
        <a-card
          title="站内通知"
          headStyle="font-weight: bolder;font-size: 18px"
        >
          <a-form :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-item label="站内通知">
              <a-switch
                v-model:checked="state.insideOption.showEnable"
                checked-children="开"
                un-checked-children="关"
              />
            </a-form-item>
            <div v-if="state.insideOption.showEnable">
              <a-form-item label="接收上限">
                <a-radio-group
                  v-model:value="state.insideOption.threshold"
                  @change="state.insideOption.handlerThresholdCheck"
                >
                  <a-radio :value="1">无</a-radio>
                  <a-radio :value="2">自定义接收数量上限</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item
                v-if="state.insideOption.thresholdEnable"
                label="数量限制"
              >
                <a-input-number
                  v-model:value="state.insideOption.thresholdSize"
                  min="0"
                  max="9999"
                  style="width: 100px"
                />
                条/天，<span style="color: red"
                  >超过数量限制时，将不再接收该类消息</span
                >
              </a-form-item>
              <a-form-item label="订阅规则">
                <a-radio-group
                  v-model:value="state.insideOption.subRule"
                  @change="state.insideOption.handlerSubRuleCheck"
                >
                  <a-radio :value="1">无</a-radio>
                  <a-radio :value="2">
                    <a-tooltip>
                      <template #title
                        >您将无法收到白名单关键词之外的任何消息
                      </template>
                      白名单关键词
                    </a-tooltip>
                  </a-radio>
                  <a-radio :value="3">
                    <a-tooltip>
                      <template #title
                        >您将无法收到包含黑名单任一关键词的信息
                      </template>
                      黑名单关键词
                    </a-tooltip>
                  </a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item
                label="订阅关键词"
                v-if="state.insideOption.kwEnable"
              >
                <a-select
                  v-model:value="state.insideOption.keywords"
                  mode="tags"
                  style="width: 100%;"
                  size="large"
                  :token-separators="[',']"
                  placeholder="多个关键词，请用回车分隔"
                  :options="options"
                  @change="handleChange"
                ></a-select>

                <div class="kw-panel ">
                  <div>
                    不区分大小写（例如："scms" 可匹配 "SCMS" "Scms" 等）
                  </div>
                  <div>
                    推荐使用简短的关键词（例如："OMS 订单服务" 应拆为 "OMS" 和
                    "订单服务"）
                  </div>
                  <div>
                    若一个关键词中同时订阅多个短语，请用&&分隔（例如："独立站 &&
                    US"）
                  </div>
                </div>
              </a-form-item>
              <a-form-item label="消息提醒">
                <a-tooltip>
                  <template #title
                    >站内通知消息提醒功能，将发送站内通知消息给用户，在系统右下角提示有新消息到达
                  </template>
                  <a-switch
                    v-model:checked="state.insideOption.activeRemind"
                    checked-children="开"
                    un-checked-children="关"
                  />
                </a-tooltip>
              </a-form-item>
            </div>
          </a-form>
        </a-card>

        <!--飞书渠道-->
        <a-card
          title="飞书个人"
          headStyle="font-weight: bolder;font-size: 18px"
        >
          <a-form :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-item label="飞书个人">
              <a-switch
                v-model:checked="state.fsOption.showEnable"
                checked-children="开"
                un-checked-children="关"
              />
            </a-form-item>
            <div v-if="state.fsOption.showEnable">
              <a-form-item label="接收上限">
                <a-radio-group
                  v-model:value="state.fsOption.threshold"
                  @change="state.fsOption.handlerThresholdCheck"
                >
                  <a-radio :value="1">无</a-radio>
                  <a-radio :value="2">自定义接收数量上限</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item
                v-if="state.fsOption.thresholdEnable"
                label="数量限制"
              >
                <a-input-number
                  v-model:value="state.fsOption.thresholdSize"
                  min="0"
                  max="9999"
                  style="width: 100px"
                />
                条/天，<span style="color: red"
                  >超过数量限制时，将不再接收该类消息</span
                >
              </a-form-item>
              <a-form-item label="订阅规则">
                <a-radio-group
                  v-model:value="state.fsOption.subRule"
                  @change="state.fsOption.handlerSubRuleCheck"
                >
                  <a-radio :value="1">无</a-radio>
                  <a-radio :value="2">
                    <a-tooltip>
                      <template #title
                        >您将无法收到白名单关键词之外的任何消息
                      </template>
                      白名单关键词
                    </a-tooltip>
                  </a-radio>
                  <a-radio :value="3">
                    <a-tooltip>
                      <template #title
                        >您将无法收到包含黑名单任一关键词的信息
                      </template>
                      黑名单关键词
                    </a-tooltip>
                  </a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="订阅关键词" v-if="state.fsOption.kwEnable">
                <a-select
                  v-model:value="state.fsOption.keywords"
                  mode="tags"
                  style="width: 100%;"
                  size="large"
                  :token-separators="[',']"
                  placeholder="多个关键词，请用回车分隔"
                  :options="options"
                  @change="handleChange"
                ></a-select>

                <div class="kw-panel ">
                  <div>
                    不区分大小写（例如："scms" 可匹配 "SCMS" "Scms" 等）
                  </div>
                  <div>
                    推荐使用简短的关键词（例如："OMS 订单服务" 应拆为 "OMS" 和
                    "订单服务"）
                  </div>
                  <div>
                    若一个关键词中同时订阅多个短语，请用&&分隔（例如："独立站 &&
                    US"）
                  </div>
                </div>
              </a-form-item>
            </div>
          </a-form>
        </a-card>
        <a-card title="飞书群" headStyle="font-weight: bolder;font-size: 18px">
          <a-form :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-item label="飞书群">
              <a-switch
                v-model:checked="state.fsGroupOption.showEnable"
                checked-children="开"
                un-checked-children="关"
              />
            </a-form-item>
            <div v-if="state.fsGroupOption.showEnable">
              <a-form-item label="app id">
                <a-input v-model:value="state.fsGroupOption.appId" />
              </a-form-item>
              <a-form-item label="app secret">
                <a-input
                  v-model:value="state.fsGroupOption.appSecret"
                  type="password"
                />
              </a-form-item>
            </div>
          </a-form>
        </a-card>
      </a-space>
    </a-modal>
  </template>
</template>

<script>
import { nextTick, reactive, ref } from 'vue'
import { message } from 'ant-design-vue'
import {
  get_message_type_subscribe_setting,
  update_message_type_subscribe_setting
} from 'server/modules/message.js'
import guideService from '@/utils/guide'

export default {
  name: 'messageSetting',
  setup() {
    const remoteTableRef = ref(null)
    const state = reactive({
      subscribeId: null,
      messageTypeCode: null,
      editEnable: false,
      //站内信渠道
      insideOption: {
        showEnable: false,
        kwEnable: false,
        thresholdEnable: false,
        threshold: 1, //上限1:无 2:自定义
        thresholdSize: null, // 自定义接收上限
        subRule: 1, //订阅规则，1:无 2:白名单 3:黑名单
        keywords: [], // 订阅关键词
        activeRemind: true, // 消息弹窗提醒 false：关闭 true：打开

        // 处理站内信处理接收限制
        handlerThresholdCheck: e => {
          state.insideOption.thresholdEnable = e.target.value === 2
        },

        // 站内信处理订阅规则
        handlerSubRuleCheck: e => {
          state.insideOption.subRule = e.target.value
          state.insideOption.kwEnable =
            e.target.value === 2 || e.target.value === 3
        }
      },
      //飞书个人渠道
      fsOption: {
        showEnable: false,
        kwEnable: false,
        thresholdEnable: false,
        threshold: 1, //上限1:无 2:自定义
        thresholdSize: null, // 自定义接收上限
        subRule: 1, //订阅规则，1:无 2:白名单 3:黑名单
        keywords: [], // 订阅关键词

        // 处理站内信处理接收限制
        handlerThresholdCheck: e => {
          state.fsOption.thresholdEnable = e.target.value === 2
        },

        // 站内信处理订阅规则
        handlerSubRuleCheck: e => {
          state.fsOption.subRule = e.target.value
          state.fsOption.kwEnable = e.target.value === 2 || e.target.value === 3
        }
      },
      //飞书群渠道
      fsGroupOption: {
        showEnable: false,
        appId: null,
        appSecret: null
      },
      scrollY: 500,
      dataUrl: `${process.env.VUE_APP_MESSAGE}/notice/subscribe/list`,
      columns: [
        {
          title: '消息类型组',
          dataIndex: 'groupName',
          key: 'groupName',
          width: 80
        },
        {
          title: '消息类型',
          dataIndex: 'typeName',
          key: 'typeName'
        },
        {
          title: '订阅渠道',
          dataIndex: 'channelTypes',
          key: 'channelTypes',
          width: 80,
          slots: { title: 'channelTypes' }
        },
        {
          title: '操作',
          dataIndex: '',
          key: 'action',
          width: 80,
          slots: { title: 'action' }
        }
      ],
      allChannels: [
        { label: '站内消息', value: 1 },
        { label: '飞书个人', value: 2 },
        { label: '飞书群', value: 3 }
      ]
    })

    const getChannelLabels = channelTypes => {
      console.log('channelTypes', channelTypes)
      const labels = channelTypes
        ? state.allChannels.filter(item => channelTypes.includes(item.value))
        : []
      console.log('labels', labels)
      return labels
    }

    const onEdit = async record => {
      state.subscribeId = record.subscribeId
      state.messageTypeCode = record.typeCode
      state.editEnable = true

      resetOptions()

      const { success, data } = await get_message_type_subscribe_setting(
        record.typeCode
      )
      if (success) {
        const subChannels = data?.channels
        subChannels.forEach(item => {
          switch (item.channelType) {
            case 1:
              state.insideOption.showEnable = true
              state.insideOption.threshold = item.threshold
              state.insideOption.thresholdEnable = item.threshold === 2
              state.insideOption.thresholdSize = item.thresholdSize
              state.insideOption.subRule = item.subRuleType
              state.insideOption.kwEnable =
                item.subRuleType === 2 || item.subRuleType === 3
              state.insideOption.keywords = item.keywords ? item.keywords : []
              state.insideOption.activeRemind = item.activeRemind > 0
              break
            case 2:
              state.fsOption.showEnable = true
              state.fsOption.threshold = item.threshold
              state.fsOption.thresholdEnable = item.threshold === 2
              state.fsOption.thresholdSize = item.thresholdSize
              state.fsOption.kwEnable =
                item.subRuleType === 2 || item.subRuleType === 3
              state.fsOption.subRule = item.subRuleType
              state.fsOption.keywords = item.keywords ? item.keywords : []
              break
            case 3:
              state.fsGroupOption.showEnable = true
              state.fsGroupOption.appId = item.appId
              state.fsGroupOption.appSecret = item.appSecret
          }
        })
      }
    }

    //更新or订阅配置
    const saveOrUpdate = async () => {
      const param = {
        subscribeId: state.subscribeId,
        typeCode: state.messageTypeCode,
        channels: []
      }

      if (state.insideOption.showEnable) {
        param.channels.push({
          channelType: 1,
          threshold: state.insideOption.thresholdEnable ? 2 : 1, //接收上限类型（1：无限制 2：自定义上限）
          thresholdSize: state.insideOption.thresholdEnable
            ? state.insideOption.thresholdSize
            : null, //自定义上限数量
          subRuleType: state.insideOption.subRule,
          keywords: state.insideOption.kwEnable
            ? state.insideOption.keywords
            : null,
          activeRemind: state.insideOption.activeRemind ? 1 : 0
        })
      }

      if (state.fsOption.showEnable) {
        param.channels.push({
          channelType: 2,
          threshold: state.fsOption.thresholdEnable ? 2 : 1, //接收上限类型（1：无限制 2：自定义上限）
          thresholdSize: state.fsOption.thresholdEnable
            ? state.fsOption.thresholdSize
            : null, //自定义上限数量
          subRuleType: state.fsOption.subRule,
          keywords: state.fsOption.kwEnable ? state.fsOption.keywords : null
        })
      }

      if (state.fsGroupOption.showEnable) {
        param.channels.push({
          channelType: 3,
          appId: state.fsGroupOption.appId,
          appSecret: state.fsGroupOption.appSecret
        })
      }

      const { success, retInfo } = await update_message_type_subscribe_setting(
        param
      )

      if (success) {
        state.editEnable = false
        await nextTick(() => {
          remoteTableRef.value?.refresh()
        })
      } else {
        message.error(retInfo)
      }
    }

    const resetOptions = () => {
      // 重置 insideOption 为默认值
      state.insideOption.showEnable = false
      state.insideOption.kwEnable = false
      state.insideOption.thresholdEnable = false
      state.insideOption.threshold = 1
      state.insideOption.thresholdSize = null
      state.insideOption.subRule = 1
      state.insideOption.keywords = []
      state.insideOption.activeRemind = 1

      // 重置 fsOption 为默认值
      state.fsOption.showEnable = false
      state.fsOption.kwEnable = false
      state.fsOption.thresholdEnable = false
      state.fsOption.threshold = 1
      state.fsOption.thresholdSize = null
      state.fsOption.subRule = 1
      state.fsOption.keywords = []

      // 重置 fsGroupOption 为默认值
      state.fsGroupOption.showEnable = false
      state.fsGroupOption.appId = null
      state.fsGroupOption.appSecret = null
    }

    const onTableDataLoaded = data => {
      // 数据加载完成后执行引导
      nextTick(() => {
        checkAndShowSubscribeGuide()
      })
    }

    // 检查并显示订阅设置引导
    const checkAndShowSubscribeGuide = () => {
      const tableElement = document.querySelector(
        '[data-guide-id="notice-subscribe-list"]'
      )

      if (tableElement) {
        guideService.registerGuide('noticeSubscribe', [
          {
            element: tableElement,
            intro:
              '这里展示了所有可订阅的消息类型，您可以为每种消息类型设置不同的订阅渠道；点击“订阅”按钮可以为该消息类型配置订阅规则',
            position: 'left'
          }
        ])

        // 检查是否显示过引导
        if (!guideService.hasShownGuide('noticeSubscribe')) {
          guideService.startGuide('noticeSubscribe', () => {
            guideService.markGuideAsShown('noticeSubscribe')
          })
        }
      }
    }

    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      state,
      onEdit,
      saveOrUpdate,
      getChannelLabels,
      onTableDataLoaded,
      remoteTableRef
    }
  }
}
</script>

<style lang="scss" scoped>
.kw-panel {
  padding-top: 8px;
}

.kw-panel div {
  color: grey;
  padding-top: 4px;
  font-size: 12px;
  font-style: italic;
}
</style>
